import React, { useEffect, useRef, useState } from 'react';

const ROW_COUNT = 5;

export default function ChannelPlatformTable({
    platformLabel,
    channels,
    busy,
    onToggle,
    onSetAll,
}) {
    const scrollerRef = useRef(null);
    const [showFade, setShowFade] = useState(channels.length > ROW_COUNT);

    const allOn = channels.length > 0 && channels.every((ch) => ch.alertsEnabled !== false);

    useEffect(() => {
        const node = scrollerRef.current;
        if (!node) return;
        const update = () => {
            const canScroll = node.scrollHeight > node.clientHeight + 2;
            const atBottom = node.scrollTop + node.clientHeight >= node.scrollHeight - 4;
            setShowFade(canScroll && !atBottom);
        };
        update();
        node.addEventListener('scroll', update, { passive: true });
        return () => node.removeEventListener('scroll', update);
    }, [channels.length]);

    return (
        <div className="profile-channel-table">
            <div className="profile-channel-table-head">
                <div className="profile-channel-table-title">
                    <span>{platformLabel}</span>
                    <span className="profile-channel-table-count">{channels.length}</span>
                </div>
                <button
                    type="button"
                    className="profile-text-btn"
                    disabled={busy || channels.length === 0}
                    onClick={() => onSetAll(!allOn)}
                >
                    {allOn ? 'Deselect all' : 'Select all'}
                </button>
            </div>
            <div className={`profile-channel-table-shell${showFade ? ' has-fade' : ''}`}>
                <ul ref={scrollerRef} className="profile-channel-table-scroll">
                    {channels.map((channel) => {
                        const isActive = channel.alertsEnabled !== false;
                        return (
                            <li key={channel.id} className="profile-channel-table-row">
                                <span className="profile-channel-name">{channel.sourceName}</span>
                                <label className={`active-toggle${busy ? ' active-toggle--disabled' : ''}`}>
                                    <input
                                        type="checkbox"
                                        className="active-toggle-input"
                                        checked={isActive}
                                        disabled={busy}
                                        onChange={(e) => onToggle(channel.id, e.target.checked)}
                                        aria-label={`${isActive ? 'Disable' : 'Enable'} alerts for ${channel.sourceName}`}
                                    />
                                    <span className="active-toggle-track" aria-hidden="true">
                                        <span className="active-toggle-thumb" />
                                    </span>
                                </label>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}
